import Media from './media';

export default class Link {
  desktop: Media | null;
  mobile: Media | null;
  poster: Media | null;
  useParallaxEffect: boolean;

  constructor(props: any) {
    this.desktop = props.mediaDesktop ? new Media(props.mediaDesktop) : null;
    this.mobile = props.mediaMobile ? new Media(props.mediaMobile) : null;
    this.poster = props.videoPoster ? new Media(props.videoPoster) : null;
    this.useParallaxEffect = props.useParallaxEffect;
  }
}
